// Meta Pixel — PageView on every Turbo navigation.
//
// The pixel snippet in app/views/layouts/_facebook_pixel.html.erb lives in
// <head>, which Turbo Drive does not re-execute on subsequent visits. Without
// a turbo:load listener, PageView fires only on the first cold load and every
// in-app navigation is invisible to Meta.
//
// fbq is queue-aware: if fbevents.js is still loading, calls are buffered and
// flushed on ready. Safe to invoke from turbo:load even before the external
// script resolves.

document.addEventListener('turbo:load', () => {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView')
  }
})
